import { useEffect, useRef, useState } from 'react';
import { embedDashboard } from '@superset-ui/embedded-sdk';

import { SupersetAPI } from 'data/Superset/superset.datasource';
import { Select } from '@chakra-ui/react';

const WF_DASHBOARD_UUID = '5de43658-f030-4ed7-975e-6ef23777f4d4';

const CURRENT_YEAR = new Date().getFullYear();
const MIN_YEAR = 2023;

const YEAR_OPTIONS = Array.from({ length: CURRENT_YEAR - MIN_YEAR + 1 }).map(
    (_, index) => CURRENT_YEAR - index
);

export default function WorkflowDashboard() {
    const dashboardContainerRef = useRef<HTMLDivElement>(null);

    const [selectedYear, setSelectedYear] = useState(CURRENT_YEAR);

    useEffect(() => {
        const containerDashboard = dashboardContainerRef.current;
        if (!containerDashboard) return;

        void (async function () {
            const { access_token } = await SupersetAPI.loginAsync();
            const { csfrToken, referer } = await SupersetAPI.getCSFRTokenAsync(access_token);
            const { token: guestToken } = await SupersetAPI.getGuestTokenAsync({
                accessToken: access_token,
                csfrToken,
                referer,
                uuid: WF_DASHBOARD_UUID,
                rls: [
                    {
                        clause: `datex >= '${selectedYear}0101' and datex <= '${selectedYear}1231'`,
                        dataset: 31
                    }
                ]
            });

            embedDashboard({
                id: WF_DASHBOARD_UUID,
                supersetDomain: SupersetAPI.SUPERSET_BASE,
                mountPoint: containerDashboard,
                fetchGuestToken: async () => guestToken,
                dashboardUiConfig: {
                    hideTitle: true,
                    hideTab: true,
                    hideChartControls: true,
                    urlParams: {},
                    filters: {
                        expanded: false,
                        visible: false
                    }
                }
            });
        })();
    }, [selectedYear]);

    return (
        <div className="mt-2 flex flex-1 flex-col gap-4">
            <div className="flex items-center gap-2 self-end">
                <span className="font-semibold">Year</span>
                <Select
                    value={selectedYear}
                    onChange={event => setSelectedYear(Number(event.target.value))}
                >
                    {YEAR_OPTIONS.map(year => (
                        <option
                            key={year}
                            value={year}
                        >
                            {year}
                        </option>
                    ))}
                </Select>
            </div>

            <div
                ref={dashboardContainerRef}
                className="flex flex-1 flex-col [&_iframe]:flex-1 [&_iframe]:rounded-lg [&_iframe]:border-none"
            />
        </div>
    );
}
